// This icon file is generated automatically.

import { IconDefinition } from '../types';

const KeyFilled: IconDefinition = {
  icon: {
    tag: 'svg',
    attrs: {
      fill: 'currentColor',
      viewBox: '0 0 18 17',
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
    },
    children: [
      {
        tag: 'path',
        attrs: {
          d: 'm16.98 2.98-.4-1.18a1 1 0 0 0-.2-.32l-1.1-1.1A1.26 1.26 0 0 0 13.5.36L7.07 6.79a4.8 4.8 0 1 0 3.3 3.3l1.5-1.5.45-1.35a.8.8 0 0 1 .53-.53l.96-.31a.8.8 0 0 0 .52-.53l.22-.66a.8.8 0 0 1 .94-.55 1.3 1.3 0 0 0 1.49-1.68m-9.8 9.87a2.03 2.03 0 1 1-2.86-2.87 2.03 2.03 0 0 1 2.87 2.87',
        },
      },
    ],
  },
  name: 'key',
  theme: 'filled',
};

export default KeyFilled;
